import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, PRICE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-oportunidad" className="bg-night" data-id="element-55" data-mp="c8c21b44epg7">
      <div className="mx-auto max-w-2xl px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-56" data-mp="84xjodsplwzl">
        <Reveal data-id="element-57" data-mp="m4ovc7vr71af">
          <h2 id="ultima-oportunidad" className="font-display text-xl uppercase leading-tight text-volt sm:text-3xl" data-id="element-58" data-mp="m46o6g7jz2nq">
            Una última oportunidad
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-59" data-mp="vtq8lqawz4kp">
            Puedes seguir guardando videos y preguntándote qué deberías
            aprender primero.{' '}
            <span className="font-bold text-white" data-id="element-60" data-mp="14whk1q3si0cc">
              O puedes comenzar hoy a construir una habilidad útil siguiendo
              una ruta desde cero.
            </span>
          </p>
          <p className="mt-2 font-script text-2xl leading-tight text-volt sm:text-3xl" data-id="element-61" data-mp="2c5pwtv1z1c26">
            No necesitas saber electricidad para empezar. Necesitas dar el
            primer paso.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-4 rounded-2xl border-2 border-volt bg-carbon p-4 sm:p-6" data-id="element-62" data-mp="2m19hflb34obm">
          <h3 className="font-display text-base uppercase leading-tight text-volt sm:text-2xl" data-id="element-63" data-mp="2qzks1y97f2uw">
            ⚡ {PRODUCT}
          </h3>
          <p className="mt-1 font-display text-base uppercase text-white sm:text-xl" data-id="element-64" data-mp="301tx48lpe40w">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-2 text-[0.75rem] font-bold uppercase text-steel sm:text-sm" data-id="element-65" data-mp="34tu42l06xx6z">
            Valor de los bonos:{' '}
            <span className="line-through decoration-danger decoration-2" data-id="element-66" data-mp="39u9hfckh34oy">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="mt-2 text-[0.7rem] font-bold uppercase tracking-[0.24em] text-steel sm:text-xs" data-id="element-67" data-mp="3isld3t074so9">
            Hoy:
          </p>
          <p className="font-display text-4xl leading-none text-volt sm:text-5xl" data-id="element-68" data-mp="1jov19uiv8edy">
            {PRICE}
          </p>

          <div className="mt-4 flex flex-col items-center gap-2" data-id="element-69" data-mp="1en5rei7dq6rg">
            <CtaButton size="lg" data-id="element-70" data-mp="1shgktcubmp3u">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-71" data-mp="1npeysz7cpk0m">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-72" data-mp="1xg0578t9nsu3">•</span>
              Entrega Digital
              <span aria-hidden="true" data-id="element-73" data-mp="1xi47jmbiojs9">•</span>
              <span className="flex items-center gap-1" data-id="element-74" data-mp="2behq6yrser8b">
                <ShieldCheckIcon size={13} className="text-volt" data-id="element-75" data-mp="27dxv00qrxxot" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}